import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { fetchAuditById, fetchAuditVersionHistory } from '@/api/audits';
import { auditDetailKeys } from '@/app/(client)/audits/-hooks/useAuditDetail';
import {
  auditDigitizationKeys,
  loadAuditDigitization,
} from '@/app/(client)/audits/-hooks/useAuditDigitization';
import { VERSION_HISTORY_PAGE_SIZE } from '@/app/(client)/audits/-hooks/useAuditVersionHistory';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/audits/(pages)/(detail)/$auditId',
)({
  loader: async ({ params }) => {
    const audit = await queryClient.ensureQueryData({
      queryKey: auditDetailKeys.detail(params.auditId),
      queryFn: () => fetchAuditById(params.auditId),
    });
    // Warm the version-history first page so the overview tab renders without
    // a fetch spinner on first load.
    void queryClient.ensureQueryData({
      queryKey: ['audits', 'version-history', params.auditId, 1, undefined, {}],
      queryFn: () => {
        const qs = new URLSearchParams({
          page: '0',
          count: String(VERSION_HISTORY_PAGE_SIZE),
        });
        return fetchAuditVersionHistory(params.auditId, qs.toString());
      },
    });
    // Warm the digitization record so the digitized tabs render without a
    // fetch spinner. Resolves to null for non-digitized (or not-yet-analyzed)
    // audits — cheap and harmless.
    void queryClient.ensureQueryData({
      queryKey: auditDigitizationKeys.detail(params.auditId),
      queryFn: () => loadAuditDigitization(params.auditId),
    });
    return audit;
  },
  component: lazyRouteComponent(
    () => import('../../../-components/AuditDetailLayout'),
    'AuditDetailLayout',
  ),
});
